import React, { useEffect, useState } from "react";
import styles from "./DetailIncomeAndExpenses.module.css";
import {
  FooterLeft,
  FooterIndex,
  TableIncomeAndExpenses,
  HeaderIncomeAndExpense,
  Navbar,
} from "../../components/";
import {
  TableIncomeAndExpensesCompany,
  HeaderIncomeAndExpenseCompany,
} from "../../components/Company/";
import { useLocation } from "react-router-dom";

const DetailIncomeAndExpensesL = () => {
  const [isNavBarVisible, setIsNavBarVisible] = useState(true);
  const [reloadData, setReloadData] = useState(false);
  const location = useLocation();
  let data = location.state;

  //Utilizar el sesion storage está limitado a la pestaña o ventana actual, y los datos se borran cuando se cierra la pestaña o ventana.
  if (!data) {
    const storedData = sessionStorage.getItem("reportData");
    if (storedData) {
      data = JSON.parse(storedData);
    }
  } else {
    // Almacena los datos en sessionStorage si están disponibles.
    sessionStorage.setItem("reportData", JSON.stringify(data));
  }

  useEffect(() => {
    const mediaQuery = window.matchMedia(
      "(min-width: 0px) and (max-width: 780px)"
    );
    setIsNavBarVisible(!mediaQuery.matches);
    const handler = (event) => setIsNavBarVisible(!event.matches);
    mediaQuery.addEventListener("change", handler);
    return () => mediaQuery.removeEventListener("change", handler);
  }, []);

  const reloadChildData = () => {
    setReloadData((prevReloadData) => !prevReloadData);
  };

  return (
    <div className={styles.Lealtadalli_g2}>
      <Navbar />
      <div className={styles.LealtadmainContainer}>
        {isNavBarVisible && <FooterLeft />}
        <div className={styles.Lealtadcontainer}>
          {data && data.typeCustomer === "Persona Jurídica" ? (
            <>
              <HeaderIncomeAndExpenseCompany
                reloadChildData={reloadChildData}
                data={data}
              />
              <TableIncomeAndExpensesCompany
                reloadData={reloadData}
                data={data}
              />
            </>
          ) : (
            <>
              <HeaderIncomeAndExpense
                reloadChildData={reloadChildData}
                data={data}
              />
              <TableIncomeAndExpenses reloadData={reloadData} data={data} />
            </>
          )}
        </div>
      </div>
      <FooterIndex />
    </div>
  );
};

export default DetailIncomeAndExpensesL;
